export default [
  {
    path: 'about',
    component: () => import('@/App.vue'),
    meta: {
      title: 'About',
      sort: 6,
      authenticatable: true,
      icon: 'mdi-flask',
    },
    children: [
      {
        path: '',
        props: true,
        name: 'about',
        component: () => import('../About.vue'),
        meta: {
          title: 'About',
          sort: 6,
          authenticatable: true,
          icon: 'mdi-flask',
        },
      },
    ],
  }
]
